import { render, staticRenderFns } from "./NotificationActionPanel.vue?vue&type=template&id=b0f82b50&scoped=true&"
import script from "./NotificationActionPanel.vue?vue&type=script&lang=js&"
export * from "./NotificationActionPanel.vue?vue&type=script&lang=js&"
import style0 from "./NotificationActionPanel.vue?vue&type=style&index=0&id=b0f82b50&scoped=true&lang=css&"
import style1 from "./NotificationActionPanel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f82b50",
  null
  
)

export default component.exports